namespace Matrix.Data {
    export interface FieldCustomizationRow {
        RowCode?: string;
        FieldName?: string;
        DisplayName?: string;
        Alias?: string;
        RemoveField?: boolean;
        VisibleInForm?: boolean;
        Insertable?: boolean;
        Updatable?: boolean;
        IsRequired?: boolean;
        FormTab?: string;
        FormCategory?: string;
        FormWidth?: string;
        FormWidthUntilNext?: boolean;
        FormWidthJustThis?: boolean;
        LabelWidth?: string;
        LabelWidthUntilNext?: boolean;
        LabelWidthJustThis?: boolean;
        DefaultValue?: string;
        MaxLength?: number;
        DecimalPlaces?: number;
        DateTimeKind?: System.DateTimeKind;
        EditorType?: string;
        EditorParams?: { [key: string]: any };
        VisibleInGrid?: boolean;
        EditLink?: boolean;
        Width?: number;
        Alignment?: string;
        FormatterType?: string;
        FormatterParams?: { [key: string]: any };
        DisplayFormat?: string;
        FilterOnly?: boolean;
        Cloneable?: boolean;
        QuickSearchType?: Serenity.Data.Mapping.SearchType;
        LookupInclude?: boolean;
        DisplayOrder?: number;
        SortOrder?: number;
        GroupOrder?: number;
        SummaryType?: number;
        ReadPermission?: string;
        ModifyPermission?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace FieldCustomizationRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'RowCode';
        export const localTextPrefix = 'Data.FieldCustomization';
        export const deletePermission = 'DataAdmin:RowCustomization';
        export const insertPermission = 'DataAdmin:RowCustomization';
        export const readPermission = 'Read:RowCustomization';
        export const updatePermission = 'DataAdmin:RowCustomization';

        export declare const enum Fields {
            RowCode = "RowCode",
            FieldName = "FieldName",
            DisplayName = "DisplayName",
            Alias = "Alias",
            RemoveField = "RemoveField",
            VisibleInForm = "VisibleInForm",
            Insertable = "Insertable",
            Updatable = "Updatable",
            IsRequired = "IsRequired",
            FormTab = "FormTab",
            FormCategory = "FormCategory",
            FormWidth = "FormWidth",
            FormWidthUntilNext = "FormWidthUntilNext",
            FormWidthJustThis = "FormWidthJustThis",
            LabelWidth = "LabelWidth",
            LabelWidthUntilNext = "LabelWidthUntilNext",
            LabelWidthJustThis = "LabelWidthJustThis",
            DefaultValue = "DefaultValue",
            MaxLength = "MaxLength",
            DecimalPlaces = "DecimalPlaces",
            DateTimeKind = "DateTimeKind",
            EditorType = "EditorType",
            EditorParams = "EditorParams",
            VisibleInGrid = "VisibleInGrid",
            EditLink = "EditLink",
            Width = "Width",
            Alignment = "Alignment",
            FormatterType = "FormatterType",
            FormatterParams = "FormatterParams",
            DisplayFormat = "DisplayFormat",
            FilterOnly = "FilterOnly",
            Cloneable = "Cloneable",
            QuickSearchType = "QuickSearchType",
            LookupInclude = "LookupInclude",
            DisplayOrder = "DisplayOrder",
            SortOrder = "SortOrder",
            GroupOrder = "GroupOrder",
            SummaryType = "SummaryType",
            ReadPermission = "ReadPermission",
            ModifyPermission = "ModifyPermission",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
